import { AssetSvgProps } from "../../../shared/assets"

export const defaultColors = {
    "col1l": "#E4B670",
    "col1n": "#D19532",
    "col2n": "#FFFFFF"
}
function SkiWou017({ colors = defaultColors, className, onClick, outerTransform, transform, startDrag }: AssetSvgProps) {
    return (
        <g transform={outerTransform}><g className={className} onClick={onClick} transform={transform} onMouseDown={startDrag} onTouchStart={startDrag}><defs>
                <path
                    fill={colors.col1n}
                    d="M41.1 13.3l2.8-2.8q1.25-1.45.95-3.8-.4-2.35-2.35-4.25-2-1.9-4.3-2.35-2.35-.4-3.75.95l-3.1 3.2-.1.1-4.15 4.3v.05l-4.5 4.65-5.45-5.45-.4-.3-2.9-2.9q-.25-.2-.55-.4l-2.8-2.8Q9.05.25 6.7.55 4.35.95 2.45 2.9.55 4.9.1 7.2q-.4 2.35.95 3.75l3.2 3.1.1.1 4.3 4.15h.05l4.6 4.45-1.4 1.4.05.05-4.1 4.1-.3.4-2.9 2.9q-.2.25-.4.55l-2.8 2.8Q.2 36.4.5 38.75.9 41.1 2.85 43q2 1.9 4.3 2.35 2.35.4 3.75-.95l3.1-3.2.1-.1 4.15-4.3v-.05l3.2-3.3-.05-.05 1.25-1.2q.05-.05.15-.05l1.35 1.35.05-.05 4.1 4.1.4.3 2.9 2.9q.25.2.55.4l2.8 2.8q1.45 1.25 3.8.95 2.35-.4 4.25-2.35 1.9-2 2.35-4.3.4-2.35-.95-3.75l-3.2-3.1-.1-.1-4.3-4.15h-.05l-3.3-3.2-.05.05-1.35-1.35 5.45-5.5.3-.4 2.9-2.9q.2-.25.4-.55z"
                    id="SkiWou017__Symbol_41_0_Layer0_0_FILL"
                />
                <path
                    fill={colors.col1l}
                    d="M43 42.55q1.9-2 2.35-4.3.4-2.35-.95-3.75l-3.2-3.1-.1-.1-4.3-4.15h-.05l-3.3-3.2-.05.05-1.35-1.35-9.3 9.45 1.4 1.4.05-.05 4.1 4.1.4.3 2.9 2.9q.25.2.55.4l2.8 2.8q1.45 1.25 3.8.95 2.35-.4 4.25-2.35M41.1 13.3l2.8-2.8q1.25-1.45.95-3.8-.4-2.35-2.35-4.25-2-1.9-4.3-2.35-2.35-.4-3.75.95l-3.1 3.2-.1.1-4.15 4.3v.05l-4.5 4.65-5.45-5.45-.4-.3-2.9-2.9q-.25-.2-.55-.4l-2.8-2.8Q9.05.25 6.7.55 4.35.95 2.45 2.9.55 4.9.1 7.2q-.4 2.35.95 3.75l3.2 3.1.1.1 4.3 4.15h.05l4.6 4.45-1.4 1.4.05.05-4.1 4.1-.3.4-2.9 2.9q-.2.25-.4.55l-2.8 2.8Q.2 36.4.5 38.75.9 41.1 2.85 43q2 1.9 4.3 2.35 2.35.4 3.75-.95l3.1-3.2.1-.1 4.15-4.3v-.05l3.2-3.3-.05-.05 1.25-1.2-9.3-9.5 9.2-9.3 9.5 9.25 5.45-5.5.3-.4 2.9-2.9q.2-.25.4-.55z"
                    id="SkiWou017__Symbol_35_0_Layer0_0_FILL"
                />
                <path
                    fill={colors.col2n}
                    d="M4.5 10.15q-.15.35-.2.7 0 .3.15.7.2.65.85 1 .7.3 1.35.05.7-.3 1.05-.95.35-.6.05-1.35-.25-.65-.9-.95-.6-.35-1.35-.1-.65.25-1 .9m-1.9-5.6q-.65-.35-1.35-.05-.7.2-1.05.85-.15.35-.2.7.05.35.15.7.2.65.85 1 .7.3 1.35.05.7-.3 1.05-.9.35-.65.05-1.4-.2-.6-.85-.95M7.25 3.4q.7-.25 1-.85.35-.7.1-1.45-.2-.6-.85-.95-.7-.3-1.35-.05-.75.25-1.1.9-.1.35-.15.65 0 .4.1.7.25.65.9 1t1.35.05m4 4.4q.7-.25 1-.9.35-.65.1-1.4-.25-.65-.9-.95-.65-.3-1.35-.1-.7.3-1.05.95-.1.35-.15.65-.05.35.1.7.25.65.9 1t1.35.05z"
                    id="SkiWou017__Symbol_34_0_Layer0_0_FILL"
                />
            </defs>
            <use
                xlinkHref="#SkiWou017__Symbol_41_0_Layer0_0_FILL"
                transform="translate(133.8 88)"
                id="SkiWou017__col1n"
            />
            <use
                xlinkHref="#SkiWou017__Symbol_35_0_Layer0_0_FILL"
                transform="translate(133.8 88)"
                id="SkiWou017__col1l"
            />
            <use
                xlinkHref="#SkiWou017__Symbol_34_0_Layer0_0_FILL"
                transform="translate(149.95 104.6)"
                id="SkiWou017__col2n"
            />
        </g></g>
    )
}
export default SkiWou017
